module.exports = __webpack_public_path__ + "img/43.e1d18aed.png";